export const fetchCourseRequestsTypes = [
  'FETCH_COURSE_REQUESTS',
  'FETCH_COURSE_REQUESTS_SUCCESS',
  'FETCH_COURSE_REQUESTS_FAIL',
];

export const resolveCourseRequestTypes = [
  'RESOLVE_COURSE_REQUEST',
  'RESOLVE_COURSE_REQUEST_SUCCESS',
  'RESOLVE_COURSE_REQUEST_FAIL',
];

export const approveInHomeTutoringRequestTypes = [
  'APPROVE_IN_HOME_TUTORING',
  'APPROVE_IN_HOME_TUTORING_SUCCESS',
  'APPROVE_IN_HOME_TUTORING_FAIL',
];

export const declineInHomeTutoringRequestTypes = [
  'DECLINE_IN_HOME_TUTORING',
  'DECLINE_IN_HOME_TUTORING_SUCCESS',
  'DECLINE_IN_HOME_TUTORING_FAIL',
];



// WEBPACK FOOTER //
// ./src/modules/requests/action_types.js